import React from "react";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";

const OrganizationRow = (props) => {
  const { sport, itemIndex, result } = props;

  return (
    <React.Fragment key={itemIndex}>
      <tr key={itemIndex}>
        <td>{result.organizationId}</td>
        <td>
          <Link to={"/organizations/" + result.organizationId + "/competitions/"} className="link">
            {result.nameLocal}
          </Link>
        </td>
        <td>
          <Link to={"/organizations/" + result.organizationId + "/competitions/"} className="link">
            {result.nameLatin}
          </Link>
        </td>
        <td>{result.countryCode}</td>
        <td className="text-right controls-5">
          {"  "}
          <Link
            to={"/organizations/" + result.organizationId + "/venues/"}
            className="btn btn-outline-secondary btn-sm btn-action"
          >
            Venues
            <i className="fas fa-chevron-right" />
          </Link>{" "}
          <Link
            to={"/organizations/" + result.organizationId + "/competitions/"}
            className="btn btn-outline-secondary btn-sm btn-action"
          >
            Competitions
            <i className="fas fa-chevron-right" />
          </Link>
        </td>
      </tr>
    </React.Fragment>
  );
};

export default injectIntl(OrganizationRow);
